export const createNestedDropdownOptions = (label, items, key = "name") => ({
	label,
	subOptions: items
		.filter(item => item.id)
		.map(item => ({
			name: item[key],
			value: item.id
		}))
})
